<template>
  <div></div>
</template>

<script>
  export default {
    name: 'DocMeta',
    props: {
      description: String,
      image: String
    },
    mounted () {
      window.setTimeout(() => {
        this.set();
      }, 1);
    },
    watch: {
      description () {
        this.set();
      },
      image () {
        this.set();
      }
    },
    methods: {
      set () {
        if (this.description) {
          document.querySelector('meta[name="description"]').setAttribute('content', this.description);
          document.querySelector('meta[property="og:description"]').setAttribute('content', this.description);
        }

        if (this.image) {
          document.querySelector('meta[property="og:image"]').setAttribute('content', this.image);
        }
      }
    }
  };
</script>
